module.exports = __webpack_public_path__ + "img/1.5KG.e8f4fe69.jpg";